module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-link.ccdeb71e.svg";